"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpTableCell = void 0;
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const types_1 = require("./types");
const table_cell_html_1 = __importDefault(require("./table-cell.html"));
let ItpTableCell = class ItpTableCell extends vue_1.default {
    cellType;
    cellValue;
    row;
    cell;
    data() {
        return {
            cellType: this.cell.column.type || 'text',
            cellValue: this.cell.value
        };
    }
    get isBool() {
        return this.cellType === 'bool';
    }
};
exports.ItpTableCell = ItpTableCell;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpTableCell.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpTableCell.prototype, "cell", void 0);
exports.ItpTableCell = ItpTableCell = __decorate([
    (0, vue_property_decorator_1.Component)({ template: table_cell_html_1.default })
], ItpTableCell);
//# sourceMappingURL=table-cell.js.map